import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "couldHaveSaved centered mb-4"
};
const _hoisted_2 = { class: "couldHaveSavedText" };
const _hoisted_3 = { class: "month" };
const _hoisted_4 = { class: "couldHaveSavedAmount" };
const _hoisted_5 = {
    key: 1,
    class: "mt-6"
};
const _hoisted_6 = {
    key: 2,
    class: "mt-6"
};
const _hoisted_7 = {
    key: 3,
    class: "centered"
};
import { ref, onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecommendedVouchersPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getRecommendedVouchers, addCustomerFavouriteDiscount, removeCustomerFavouriteDiscount } = useVouchers();
        const recommendedVouchers = ref(null);
        const daysBack = ref(-60);
        const loading = ref(true);
        const periodString = ref('');
        const totalSavings = ref(0);
        function setDaysBack(days) {
            daysBack.value = days;
            loading.value = true;
            recommendedVouchers.value = null;
            loadRecommended();
        }
        function loadRecommended() {
            getRecommendedVouchers(daysBack.value, (r) => {
                console.log(r);
                if (daysBack.value === -60) {
                    r = r.filter((v) => {
                        return v.lastMonthSpend && Math.abs(v.lastMonthSpend) > 0;
                    });
                    r.forEach((v) => {
                        v.saving = Math.abs(v.lastMonthSpend * (v.effectiveDiscountPercentage / 100));
                    });
                    const lastMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
                    periodString.value = lastMonth.toLocaleString('default', { month: 'long' });
                }
                else {
                    periodString.value = 'the past year';
                }
                console.log('Recommended vouchers:', r);
                recommendedVouchers.value = r;
                totalSavings.value = r.reduce((sum, v) => sum + (v.saving || 0), 0);
                loading.value = false;
            });
        }
        function favouriteToggled(voucher) {
            if (voucher.favourite) {
                removeCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
            else {
                addCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
        }
        onMounted(() => {
            getCustomer();
            loadRecommended();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Recommended Discounts" }),
                _createVNode(_component_v_row, { class: "topMenuRow" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "topMenuCol" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                    class: _normalizeClass(['topTabButton', { selected: daysBack.value === -60 }]),
                                    title: "",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (setDaysBack(-60)))
                                }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode("Last Month")
                                    ])),
                                    _: 1
                                }, 8, ["class"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_col, { class: "topMenuCol" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                    class: _normalizeClass(['topTabButton', { selected: daysBack.value === -365 }]),
                                    title: "",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (setDaysBack(-365)))
                                }, {
                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                        _createTextVNode("Past Year")
                                    ])),
                                    _: 1
                                }, 8, ["class"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                (!loading.value && totalSavings.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("p", _hoisted_2, [
                            _cache[5] || (_cache[5] = _createTextVNode("In ")),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(periodString.value), 1),
                            _cache[6] || (_cache[6] = _createTextVNode(" you could have saved"))
                        ]),
                        _createElementVNode("p", _hoisted_4, "£" + _toDisplayString(totalSavings.value.toFixed(2)), 1)
                    ]))
                    : _createCommentVNode("", true),
                (recommendedVouchers.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(VoucherList, {
                            showAll: true,
                            vouchers: recommendedVouchers.value,
                            search: false,
                            showSaving: true,
                            showFavourites: true,
                            spendLabel: 'Your',
                            showLastMonthSpend: daysBack.value === -60,
                            onFavouriteToggled: _cache[2] || (_cache[2] = (v) => { favouriteToggled(v); }),
                            formatter: _unref(state).formatter
                        }, null, 8, ["vouchers", "showLastMonthSpend", "formatter"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
                            return _createElementVNode("div", {
                                key: i,
                                class: "mb-2"
                            }, [
                                _createVNode(_component_v_skeleton_loader, { type: "list-item-avatar-two-line" })
                            ]);
                        }), 64))
                    ])),
                (!loading.value && recommendedVouchers.value.length == 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Sorry, we do not have any recommendations for " + _toDisplayString(periodString.value) + ". ", 1))
                    : _createCommentVNode("", true),
                _cache[7] || (_cache[7] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
            ], 64));
        };
    }
});
